import ButtonContainer from 'core/button-container';
import formatNumber from 'utils/format-number';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import LandingSection from 'components/landing/components/landing-section';
import PropTypes from 'prop-types';
import { secureStringify } from 'utils/secure-json';
import SimpleTable from 'core/simple-table';
import Spacer from 'core/spacer';
import styles from 'styles/HowMuch.module.scss';
import TextBox from 'core/text-box';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const HowMuch = ({ data, culture }) => {
    const { seoText, verification } = useGetSeoTextByIndex('home_how_much');
    const t = useTranslations('how-much');

    function getPriceDisplay (price) {
        const priceSentence = t('table.price');
        return priceSentence.replace('[price]', formatNumber(price));
    };

    const tableHeaderList = useMemo(() => [
        t('table-header.coverage-type'),
        t('table-header.average-price')
    ], []);

    const tableData = useMemo(
        () => data.map((row) => [row.type, getPriceDisplay(row.value)]),
        [secureStringify(data)]);

    if (!verification) {
        return null;
    };

    return (
        <LandingSection>
            <div className={styles.container} >
                <TextBox
                    title={seoText.section_title}
                    content={`${seoText.paragraph1.sentence1} \n \n ${seoText.paragraph2.sentence1}`}
                    titleTag="h2"
                    primaryTitleColor={true}
                />
                <div className={styles.container_item}>
                    { tableData.length > 0 && (
                        <SimpleTable tagHeaderText="h2"
                            headerList={tableHeaderList}
                            data={tableData}
                        />
                    )}
                </div>
            </div>
            <Spacer space={6} />
            <ButtonContainer align="left" width="auto">
                <FormOrRedirectButton
                    label={t('button.label')}
                    redirectWithConversio={culture === 'es-ar'}
                />
            </ButtonContainer>
        </LandingSection>
    );
};

HowMuch.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        })
    ).isRequired,
    culture: PropTypes.string.isRequired
};

export default HowMuch;
